import { ActionTypes } from '../actions';

const INITIAL_STATE = {
  authenticated: false,
  userid: null,
  firstName: '',
  lastName: '',
  completedSurveys: [],
  inProgressSurveys: [],
  extraDemographics: false,
  occupation: '',
  age: '',
  email: '',
  authError: false,
  updateError: false,
  updateSuccess: false,
};

const UserReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.UPDATE_USER:
      return {
        ...state,
        ...action.payload,
      };
    case ActionTypes.AUTH_USER:
      return {
        ...state, userid: action.payload.userid, authenticated: true, authError: false,
      };
    case ActionTypes.AUTH_ERROR:
      return { ...state, authenticated: false, authError: true };
    case ActionTypes.UPDATE_USER_ERROR:
      return { ...state, updateError: true };
    case ActionTypes.CLEAR_USER_STATUSES:
      return {
        ...state, authError: false, updateError: false, updateSuccess: false,
      };
    case ActionTypes.DEAUTH_USER:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default UserReducer;
